import {
  GET_CUSTODIANS,
  GET_CUSTODIANS_ERROR,
  GET_CUSTODIANS_SUCCESS,
  CREATE_CUSTODIAN,
  CREATE_CUSTODIAN_SUCCESS,
  CREATE_CUSTODIAN_ERROR,
  UPDATE_CUSTODIAN,
  UPDATE_CUSTODIAN_SUCCESS,
  UPDATE_CUSTODIAN_ERROR,
} from './custodiansActionConstants';

export const getCustodians = (payload) => ({
  type: GET_CUSTODIANS,
  payload,
});

export const getCustodiansSuccess = (payload) => ({
  type: GET_CUSTODIANS_SUCCESS,
  payload,
});

export const getCustodiansError = (payload) => ({
  type: GET_CUSTODIANS_ERROR,
  payload,
});

export const createCustodian = (payload) => ({
  type: CREATE_CUSTODIAN,
  payload,
});

export const createCustodianSuccess = (payload) => ({
  type: CREATE_CUSTODIAN_SUCCESS,
  payload,
});

export const createCustodianError = (payload) => ({
  type: CREATE_CUSTODIAN_ERROR,
  payload,
});

export const updateCustodian = (payload) => ({
  type: UPDATE_CUSTODIAN,
  payload,
});

export const updateCustodianSuccess = (payload) => ({
  type: UPDATE_CUSTODIAN_SUCCESS,
  payload,
});

export const updateCustodianError = (payload) => ({
  type: UPDATE_CUSTODIAN_ERROR,
  payload,
});
